export default __webpack_public_path__ + "static/media/ic_sorry.1e280c0d.svg";